module.exports = __webpack_public_path__ + "img/photo-8.d58d003a.jpg";